import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/public/dataValidator/data_validator.jpg");
;
import(/* webpackMode: "eager" */ "/app/public/engame/gamification.jpg");
;
import(/* webpackMode: "eager" */ "/app/public/homePage/icons/bullet.svg");
;
import(/* webpackMode: "eager" */ "/app/public/homePage/icons/right_arrow.svg");
;
import(/* webpackMode: "eager" */ "/app/public/homePage/technology/tabmegen.png");
;
import(/* webpackMode: "eager" */ "/app/public/inscribee/inscribee.jpg");
;
import(/* webpackMode: "eager" */ "/app/public/raven/raven.jpg");
;
import(/* webpackMode: "eager" */ "/app/public/slm/icon/home.svg");
;
import(/* webpackMode: "eager" */ "/app/public/slm/slm.jpg");
;
import(/* webpackMode: "eager" */ "/app/public/technologyAndProduct/ai.jpg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/Component/Header/index.tsx");
